<template ref="costumerSelect">
  <div class="row">
    <div class="col-12">
      <label for="inputCostumersList">Cliente</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fas fa-search fa-fw"></i>
          </span>
        </div>
        <input
          type="hidden"
          autocomplete="off"
          :required="required"
          id="costumerId"
          name="costumer_id"
        />
        <input
          type="text"
          autocomplete="off"
          class="form-control autoComplete"
          id="inputCostumersList"
          name="costumer_name"
          ref="costumers"
          placeholder="Digite para buscar o cliente"
          :required="required"
          :readonly="readonly"
          :disabled="disabled"
		  @input="search"
        />
      </div>
      <div
        v-if="found"
        id="selectCostumers"
        style="background-color: #ffffff; border-radius: 3px; position: absolute; height: auto; width: 92%; z-index: 9999; box-shadow: 0px 3px 3px #ccc;"
      >
        <div class="list-group">
          <!-- list of founded costumers -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const EventBus = new Vue;
export default {
  props: {
    required: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      found: [],
      url: window.location.pathname
    };
  },
  methods: {
    generatePhonesArray(data){
      let phones = new Array();
      let count = 0;
      while(count <= 3){
        data['telefone' + count] ? phones.push(data['telefone' + count]) : null;
        count++;
      }

      data['telphone'] ? phones.push(data['telphone']) : null;
      data['cellphone'] ? phones.push(data['cellphone']) : null;
      return phones;
	},

	async search(event){
	var self = this;
      let form = event.target.form;
      let name = event.target.value;
      await axios
        .get(self.url + "/searchClients", { params: { search: name } })
        .then(response => {
          const costumers = response.data;

          self.found = [];
          if (name.length > 0) {
            $.each(costumers, function(index, item) {
              if (
                item.fantasy_name.toLowerCase().includes(name.toLowerCase()) ||
                item.cpf_cnpj.includes(name) ||
                item.cellphone.includes(name) ||
                item.telphone.includes(name) ||
                item.corporate_name.toLowerCase().includes(name.toLowerCase())
              ) {
                item['phones'] = self.generatePhonesArray(item);
                self.found.push(item);
              }
            });

            $("#selectCostumers div.list-group button").remove();
            $.each(self.found, function(index, item) {
              var listItem = `<button type="button" data-data='${JSON.stringify(item)}' class="list-group-item list-group-item-action costumerListItem">${item.fantasy_name}</button>`;
              $("#selectCostumers div.list-group").append(listItem);
            });

          } else {
            $("#selectCostumers div.list-group button").remove();
          }

          $(document).unbind("click").on("click", function(event) {
            if (
              $(event.target).hasClass("costumerListItem") ||
              event.target.id == "inputCostumersList"
            ) {
              var elem = $(event.target);
              var data = elem.data("data");
              if(data){
                $("#inputCostumersList").val(data.fantasy_name).data('data', data);
                $("#costumerId").val(data.id);

                populate(form, data);

                $('#inputphones_list').val("");

                $("#listphones_list option").remove();
                data.phones.forEach(element => {
                  const html = `<option value="${element}">${element}</option>`
                  $("#listphones_list").append(html);
                });
              }
              self.found = 0;
            }
          });
        });
      return
	}
  }
};
</script>
